// THIS FILE IS GENERATED. ANY CHANGES TO THIS FILE WILL BE LOST.
import type { TOC } from '@ember/component/template-only';

export interface EnvelopeIconSignature {
  Element: SVGSVGElement;
}

export const EnvelopeIcon: TOC<EnvelopeIconSignature> = <template><svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" ...attributes>
<path fill-rule="evenodd" clip-rule="evenodd" d="M20 6H4C2.897 6 2 6.897 2 8V17C2 18.103 2.897 19 4 19H20C21.103 19 22 18.103 22 17V8C22 6.897 21.103 6 20 6ZM18.113 8L12 11.82L5.887 8H18.113ZM4 9.179V17H20.001L20 9.178L12.53 13.848C12.368 13.949 12.184 14 12 14C11.816 14 11.632 13.949 11.47 13.848L4 9.179Z"/>
</svg>
</template>;